import $ from 'jquery';

function initForm(formElement) {
	$(formElement)
		.on('submit', submit)
		.on('_success.form', success)
		.on('_fail.form', fail)
		.on('_reset.form', reset);
}
function submit(event) {
	event.preventDefault();

	$(this)
		.find('.form__submit')
			.prop('disabled', true);
}

function success(event, html) {
	$(this)
		.find('.form__submit')
			.prop('disabled', false)
			.end()
		.find('.form__status')
			.removeClass('form__status_type_fail')
			.addClass('form__status_visible form__status_type_success')
			.html(html);
}

function fail(event, html) {
	$(this)
		.find('.form__submit')
			.prop('disabled', false)
			.end()
		.find('.form__status')
			.removeClass('form__status_type_success')
			.addClass('form__status_visible form__status_type_fail')
			.html(html);
}

function reset() {
	this.reset();

	$(this)
		.find('.form__submit')
			.prop('disabled', false)
			.end()
		.find('.form__status')
			.removeClass('form__status_visible form__status_type_success form__status_type_fail')
			.text('');
}

export { initForm };
